import localizationData from "./en.json";
import localized from "model/events/util";

import leave from "model/actions/leave";
import raid from "model/actions/raid";
import buyFood, { buyFoodBulk } from "model/actions/city/merchant/buyFood";
import buyAmmo, { buyAmmoBulk } from "model/actions/city/merchant/buyAmmo";
import buyWater, { buyWaterBulk } from "model/actions/city/merchant/buyWater";
import sellFood from "model/actions/sellFood";
import sellAmmo from "model/actions/sellAmmo";
import sellWater from "model/actions/sellWater";

const specialEvents = (context, onDone) =>
  [
    {
      title: "event.sick.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.sick.spring.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.sick.spring.night.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.sick.summer.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.sick.summer.night.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.sick.autumn.day.description",
            effect: { resources: { health: -7 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.sick.autumn.night.description",
            effect: { resources: { health: -12 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.sick.winter.day.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 15,
          },
          night: {
            description: "event.sick.winter.night.description",
            effect: { resources: { health: -15 } },
            weightAdjustment: 20,
          },
        },
      ],
      buttons: [
        {
          title: "event.sick.button.lose.title",
          message: "event.sick.button.lose.message",
          effect: { resources: { health: -10 } },
        },
      ],
    },

    {
      title: "event.caravan.title",
      baseWeight: 20,
      condition: ({ terrain }) => !terrain.inWater,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.caravan.spring.day.description",
            effect: {},
          },
          night: {
            description: "event.caravan.spring.night.description",
            effect: {},
          },
        },
        {
          season: "summer",
          day: {
            description: "event.caravan.summer.day.description",
            effect: {},
          },
          night: {
            description: "event.caravan.summer.night.description",
            effect: {},
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.caravan.autumn.day.description",
            effect: {},
          },
          night: {
            description: "event.caravan.autumn.night.description",
            effect: {},
          },
        },
        {
          season: "winter",
          day: {
            description: "event.caravan.winter.day.description",
            effect: {},
          },
          night: {
            description: "event.caravan.winter.night.description",
            effect: {},
          },
        },
      ],
      buttons: [raid(onDone), leave(onDone)],
    },
    {
      title: "event.seaborneRaid.title",
      baseWeight: 20,
      condition: ({ terrain }) => terrain.inWater,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.seaborneRaid.spring.day.description",
            effect: {},
          },
          night: {
            description: "event.seaborneRaid.spring.night.description",
            effect: {},
          },
        },
        {
          season: "summer",
          day: {
            description: "event.seaborneRaid.summer.day.description",
            effect: {},
          },
          night: {
            description: "event.seaborneRaid.summer.night.description",
            effect: {},
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.seaborneRaid.autumn.day.description",
            effect: {},
          },
          night: {
            description: "event.seaborneRaid.autumn.night.description",
            effect: {},
          },
        },
        {
          season: "winter",
          day: {
            description: "event.seaborneRaid.winter.day.description",
            effect: {},
          },
          night: {
            description: "event.seaborneRaid.winter.night.description",
            effect: {},
          },
        },
      ],
      buttons: [raid(onDone), leave(onDone)],
    },
    {
      title: "event.theTrader.title",
      baseWeight: 25,
      condition: ({ terrain }) => !terrain.inWater,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.theTrader.spring.day.description",
            effect: {},
          },
          night: {
            description: "event.theTrader.spring.night.description",
            effect: {},
          },
        },
        {
          season: "summer",
          day: {
            description: "event.theTrader.summer.day.description",
            effect: {},
          },
          night: {
            description: "event.theTrader.summer.night.description",
            effect: {},
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.theTrader.autumn.day.description",
            effect: {},
          },
          night: {
            description: "event.theTrader.autumn.night.description",
            effect: {},
          },
        },
        {
          season: "winter",
          day: {
            description: "event.theTrader.winter.day.description",
            effect: {},
          },
          night: {
            description: "event.theTrader.winter.night.description",
            effect: {},
          },
        },
      ],
      buttons: [
        buyFood(context),
        buyFoodBulk(context),
        sellFood({ context }),
        buyWater(context),
        buyWaterBulk(context),
        sellWater({ context }),
        buyAmmo(context),
        buyAmmoBulk(context),
        sellAmmo({ context }),
        leave(onDone),
      ],
    },
    {
      title: "event.merchantShip.title",
      condition: ({ terrain }) => terrain.inWater,
      baseWeight: 25, // Base weight might be adjusted in code based on context and not hardcoded.
      variants: [
        {
          season: "spring",
          day: {
            description: "event.merchantShip.spring.day.description",
            effect: {},
          },
          night: {
            description: "event.merchantShip.spring.night.description",
            effect: {},
          },
        },
        {
          season: "summer",
          day: {
            description: "event.merchantShip.summer.day.description",
            effect: {},
          },
          night: {
            description: "event.merchantShip.summer.night.description",
            effect: {},
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.merchantShip.autumn.day.description",
            effect: {},
          },
          night: {
            description: "event.merchantShip.autumn.night.description",
            effect: {},
          },
        },
        {
          season: "winter",
          day: {
            description: "event.merchantShip.winter.day.description",
            effect: {},
          },
          night: {
            description: "event.merchantShip.winter.night.description",
            effect: {},
          },
        },
      ],
      buttons: [
        buyFood(context),
        buyFoodBulk(context),
        sellFood({ context }),
        buyWater(context),
        buyWaterBulk(context),
        sellWater({ context }),
        buyAmmo(context),
        buyAmmoBulk(context),
        sellAmmo({ context }),
        leave(onDone),
      ],
    },
    {
      title: "event.mysteriousWanderer.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.mysteriousWanderer.description.spring.day",
            effect: { resources: { food: -3 }, traits: { wisdom: +1 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.mysteriousWanderer.description.spring.night",
            effect: { resources: { coins: -5 }, traits: { luck: +1 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.mysteriousWanderer.description.summer.day",
            effect: { resources: { water: +5 }, traits: { resilience: +1 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.mysteriousWanderer.description.summer.night",
            effect: { traits: { stealth: +1 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.mysteriousWanderer.description.autumn.day",
            effect: { resources: { time: -1 }, traits: { haggling: +1 } }, // Imaginary "time" resource to signify faster travel
            weightAdjustment: 5,
          },
          night: {
            description: "event.mysteriousWanderer.description.autumn.night",
            effect: { resources: { morale: +5 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.mysteriousWanderer.description.winter.day",
            effect: { resources: { health: +5 } },
            weightAdjustment: 10,
          },
          night: {
            description: "event.mysteriousWanderer.description.winter.night",
            effect: { resources: { warmth: +5 }, traits: { charisma: +1 } }, // Imaginary "warmth" resource for illustrative purposes
            weightAdjustment: 15,
          },
        },
      ],
      buttons: [
        {
          title: "event.mysteriousWanderer.button.engage",
          message: "event.mysteriousWanderer.engageMessage",
          effect: {},
        },
        {
          title: "event.mysteriousWanderer.button.ignore",
          message: "event.mysteriousWanderer.ignoreMessage",
          isDismiss: true,
        },
      ],
    },
  ].map((event) => localized(event, localizationData));

const borderEvents = (context, onDone) =>
  [
    {
      title: "event.borderlands.title",
      baseWeight: 25,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.borderlands.spring.day.description",
          },
          night: {
            description: "event.borderlands.spring.night.description",
            weightAdjustment: -5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.borderlands.summer.day.description",
          },
          night: {
            description: "event.borderlands.summer.night.description",
            weightAdjustment: -5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.borderlands.autumn.day.description",
          },
          night: {
            description: "event.borderlands.autumn.night.description",
            weightAdjustment: -5,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.borderlands.winter.day.description",
          },
          night: {
            description: "event.borderlands.winter.night.description",
            weightAdjustment: -5,
          },
        },
      ],
      buttons: [
        {
          title: "event.borderlands.button.exchange.title",
          message: "event.borderlands.button.exchange.message",
          effect: { resources: { coins: -2, ammo: 20 } },
        },
        {
          title: "event.borderlands.button.ignore",
          message: "event.borderlands.button.ignore.message",
          isDismiss: true,
        },
      ],
    },
    {
      title: "event.bordercrossing.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.bordercrossing.spring.day.description",
          },
          night: {
            description: "event.bordercrossing.spring.night.description",
          },
        },
        {
          season: "summer",
          day: {
            description: "event.bordercrossing.summer.day.description",
          },
          night: {
            description: "event.bordercrossing.summer.night.description",
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.bordercrossing.autumn.day.description",
          },
          night: {
            description: "event.bordercrossing.autumn.night.description",
          },
        },
        {
          season: "winter",
          day: {
            description: "event.bordercrossing.winter.day.description",
          },
          night: {
            description: "event.bordercrossing.winter.night.description",
          },
        },
      ],
      buttons: [
        {
          title: "event.bordercrossing.button.leave.title",
          message: "event.bordercrossing.button.leave.message",
        },
      ],
    },
    {
      title: "event.bordercombat.title",
      baseWeight: 20,
      isCombat: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.bordercombat.spring.day.description",
            effect: { resources: { health: -5, ammo: -2 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.bordercombat.spring.night.description",
            effect: { resources: { health: -10, ammo: -3 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.bordercombat.summer.day.description",
            effect: { resources: { health: -4, ammo: -1 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.bordercombat.summer.night.description",
            effect: { resources: { health: -8, ammo: -2 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.bordercombat.autumn.day.description",
            effect: { resources: { health: -6, ammo: -2 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.bordercombat.autumn.night.description",
            effect: { resources: { health: -7, ammo: -2 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.bordercombat.winter.day.description",
            effect: { resources: { health: -7, ammo: -3 } },
            weightAdjustment: 15,
          },
          night: {
            description: "event.bordercombat.winter.night.description",
            effect: { resources: { health: -12, ammo: -4 } },
            weightAdjustment: 20,
          },
        },
      ],
      buttons: [
        {
          title: "event.bordercombat.button.fight.title",
          combat: {
            description: "event.bordercombat.button.fight.message",
            victory: "event.bordercombat.button.fight.victory",
            defeat: "event.bordercombat.button.fight.defeat",
            enemies: ["bandit", "bandit"],
          },
        },
        {
          title: "event.bordercombat.button.escape.title",
          message: "event.bordercombat.button.escape.message",
          effect: { traits: { stealth: +1 } },
        },
      ],
    },
  ].map((event) => localized(event, localizationData));

const randomEvents = (context, onDone) =>
  [
    {
      title: "event.soldiers.title",
      baseWeight: 20, // Example base weight
      variants: [
        {
          season: "spring",
          day: {
            description: "event.soldiers.spring.day.description",
            weightAdjustment: 0,
          },
          night: {
            description: "event.soldiers.spring.night.description",
            weightAdjustment: -5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.soldiers.summer.day.description",
            weightAdjustment: 5,
          },
          night: {
            description: "event.soldiers.summer.night.description",
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.soldiers.autumn.day.description",
            weightAdjustment: 10,
          },
          night: {
            description: "event.soldiers.autumn.night.description",
            weightAdjustment: 5,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.soldiers.winter.day.description",
            weightAdjustment: 15,
          },
          night: {
            description: "event.soldiers.winter.night.description",
            weightAdjustment: 10,
          },
        },
      ],
      buttons: [
        {
          title: "event.soldiers.button.exchange.title",
          message: "event.soldiers.button.exchange.message",
          effect: { resources: { food: -5, ammo: +40 } },
        },
        {
          title: "event.soldiers.button.ignore.title",
          message: "event.soldiers.button.ignore.message",
          effect: { traits: { infamy: +1 } },
        },
      ],
    },
    {
      title: "event.thief.title",
      baseWeight: 30,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.thief.spring.day.description",
            effect: { resources: { food: -25, ammo: -5 } },
          },
          night: {
            description: "event.thief.spring.night.description",
            effect: { resources: { food: -25, ammo: -5 } },
          },
        },
        {
          season: "summer",
          day: {
            description: "event.thief.summer.day.description",
            effect: { resources: { food: -25, ammo: -5 } },
          },
          night: {
            description: "event.thief.summer.night.description",
            effect: { resources: { food: -25, ammo: -5 } },
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.thief.autumn.day.description",
            effect: { resources: { food: -25, ammo: -5 } },
          },
          night: {
            description: "event.thief.autumn.night.description",
            effect: { resources: { food: -25, ammo: -5 } },
          },
        },
        {
          season: "winter",
          day: {
            description: "event.thief.winter.day.description",
            effect: { resources: { food: -25, ammo: -5 } },
          },
          night: {
            description: "event.thief.winter.night.description",
            effect: { resources: { food: -25, ammo: -5 } },
          },
        },
      ],
      buttons: [
        {
          title: "event.thief.button.lose.title",
          message: "event.thief.button.lose.message",
          effect: { resources: { food: -25, ammo: -5 } },
        },
      ],
    },
    {
      title: "event.rowdyCaravan.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.rowdyCaravan.spring.day.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.rowdyCaravan.spring.night.description",
            effect: { resources: { morale: +1 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.rowdyCaravan.summer.day.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.rowdyCaravan.summer.night.description",
            effect: { resources: { morale: +1 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.rowdyCaravan.autumn.day.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.rowdyCaravan.autumn.night.description",
            effect: { resources: { morale: +1 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.rowdyCaravan.winter.day.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.rowdyCaravan.winter.night.description",
            effect: { resources: { morale: +1 } },
            weightAdjustment: 10,
          },
        },
      ],
      buttons: [
        {
          title: "event.rowdyCaravan.button.join.title",
          message: "event.rowdyCaravan.button.join.message",
          effect: { resources: { health: +10, morale: +1 } },
        },
      ],
    },
    {
      title: "event.merchant.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.merchant.spring.day.description",
            effect: { resources: { coins: -20 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.merchant.spring.night.description",
            effect: { resources: { coins: -20 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.merchant.summer.day.description",
            effect: { resources: { coins: -20 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.merchant.summer.night.description",
            effect: { resources: { coins: -20 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.merchant.autumn.day.description",
            effect: { resources: { coins: -20 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.merchant.autumn.night.description",
            effect: { resources: { coins: -20 } },
            weightAdjustment: 15,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.merchant.winter.day.description",
            effect: { resources: { coins: -20 } },
            weightAdjustment: 10,
          },
          night: {
            description: "event.merchant.winter.night.description",
            effect: { resources: { coins: -20 } },
            weightAdjustment: 20,
          },
        },
      ],
      buttons: [
        {
          title: "event.merchant.button.accept.title",
          message: "event.merchant.button.accept.message",
          effect: { resources: { coins: -20 } },
        },
      ],
    },
    {
      title: "event.gypsies.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.gypsies.spring.day.description",
            weightAdjustment: 0,
          },
          night: {
            description: "event.gypsies.spring.night.description",
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.gypsies.summer.day.description",
            weightAdjustment: -5,
          },
          night: {
            description: "event.gypsies.summer.night.description",
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.gypsies.autumn.day.description",
            weightAdjustment: 5,
          },
          night: {
            description: "event.gypsies.autumn.night.description",
            weightAdjustment: 10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.gypsies.winter.day.description",
            weightAdjustment: 10,
          },
          night: {
            description: "event.gypsies.winter.night.description",
            weightAdjustment: 15,
          },
        },
      ],
      buttons: [
        {
          title: "event.gypsies.button.lose.title",
          message: "event.gypsies.button.lose.message",
          effect: { resources: { coins: -40 } },
        },
        {
          title: "event.gypsies.button.ignore.title",
          message: "event.gypsies.button.ignore.message",
          effect: { resources: { health: -10 } },
        },
      ],
    },
    {
      title: "event.easyTravels.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.easyTravels.spring.day.description",
            weightAdjustment: 5,
          },
          night: {
            description: "event.easyTravels.spring.night.description",
            weightAdjustment: 0,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.easyTravels.summer.day.description",
            weightAdjustment: -5,
          },
          night: {
            description: "event.easyTravels.summer.night.description",
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.easyTravels.autumn.day.description",
            weightAdjustment: 5,
          },
          night: {
            description: "event.easyTravels.autumn.night.description",
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.easyTravels.winter.day.description",
            weightAdjustment: 10,
          },
          night: {
            description: "event.easyTravels.winter.night.description",
            weightAdjustment: 5,
          },
        },
      ],
      buttons: [
        {
          title: "event.easyTravels.button.gain.title",
          message: "event.easyTravels.button.gain.message",
          effect: { resources: { food: +10, water: +10 } },
        },
      ],
    },
    {
      title: "event.wolves.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.wolves.spring.day.description",
            effect: { resources: { ammo: +5, food: +10, water: +2 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.wolves.spring.night.description",
            effect: { resources: { ammo: +10, food: +15, water: +3 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.wolves.summer.day.description",
            effect: { resources: { ammo: +3, food: +8, water: +2 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.wolves.summer.night.description",
            effect: { resources: { ammo: +8, food: +12, water: +3 } },
            weightAdjustment: 15,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.wolves.autumn.day.description",
            effect: { resources: { ammo: +4, food: +9, water: +2 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.wolves.autumn.night.description",
            effect: { resources: { ammo: +9, food: +13, water: +3 } },
            weightAdjustment: 20,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.wolves.winter.day.description",
            effect: { resources: { ammo: +6, food: +11, water: +2 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.wolves.winter.night.description",
            effect: { resources: { ammo: +11, food: +16, water: +4 } },
            weightAdjustment: 25,
          },
        },
      ],
      buttons: [
        {
          title: "event.wolves.button.collect",
          message: "event.wolves.button.message.collect",
          effect: {},
        },
      ],
    },
    {
      title: "event.wolfPack.title",
      baseWeight: 20,
      isCombat: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.wolfPack.spring.day.description",
            effect: { resources: { ammo: -5, health: -5 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.wolfPack.spring.night.description",
            effect: { resources: { ammo: -7, health: -7 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.wolfPack.summer.day.description",
            effect: { resources: { ammo: -4, health: -4 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.wolfPack.summer.night.description",
            effect: { resources: { ammo: -6, health: -6 } },
            weightAdjustment: 15,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.wolfPack.autumn.day.description",
            effect: { resources: { ammo: -5, health: -5 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.wolfPack.autumn.night.description",
            effect: { resources: { ammo: -7, health: -7 } },
            weightAdjustment: 20,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.wolfPack.winter.day.description",
            effect: { resources: { ammo: -6, health: -6 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.wolfPack.winter.night.description",
            effect: { resources: { ammo: -8, health: -8 } },
            weightAdjustment: 25,
          },
        },
      ],
      buttons: [
        {
          title: "event.wolfPack.button.defend",
          combat: {
            description: "event.wolfPack.button.message.defend",
            victory: "event.wolfPack.button.message.defend.victory",
            defeat: "event.wolfPack.button.message.defend.defeat",
            enemies: ["wolf", "wolf"],
          },
        },
      ],
    },
    {
      title: "event.blizzard.title",
      baseWeight: 20,
      isBuild: true,
      variants: [
        {
          season: "winter",
          day: {
            description: "event.blizzard.winter.day.description",
            effect: { resources: { food: -10, health: -5 } },
            weightAdjustment: 10,
          },
          night: {
            description: "event.blizzard.winter.night.description",
            effect: { resources: { food: -15, health: -10, morale: -1 } },
            weightAdjustment: 20,
          },
        },
      ],
      buttons: [
        {
          title: "event.blizzard.button.endure",
          message: "event.blizzard.button.message.endure",
          effect: { traits: { resilience: +1 }, resources: { health: -10 } },
        },
        {
          title: "event.blizzard.button.seekShelter",
          message: "event.blizzard.button.message.seekShelter",
          effect: { resources: { health: -5, morale: 5 } },
        },
      ],
    },
    {
      title: "event.ice.title",
      baseWeight: 20,
      variants: [
        {
          season: "winter",
          day: {
            description: "event.ice.winter.day.description",
            effect: { health: -10 },
            weightAdjustment: 5,
          },
          night: {
            description: "event.ice.winter.night.description",
            effect: { health: -15, morale: -1 },
            weightAdjustment: 10,
          },
        },
      ],
      buttons: [
        {
          title: "event.ice.button.proceedCarefully",
          message: "event.ice.button.message.proceedCarefully",
          effect: { resources: { resilience: +1 } },
        },
        {
          title: "event.ice.button.rest",
          message: "event.ice.button.message.rest",
          effect: { resources: { health: +5 } },
        },
      ],
    },
    {
      title: "event.snow.title",
      baseWeight: 20,
      variants: [
        {
          season: "winter",
          day: {
            description: "event.snow.winter.day.description",
            effect: { resources: { water: +15 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.snow.winter.night.description",
            effect: { resources: { water: +20 } },
            weightAdjustment: 5,
          },
        },
      ],
      buttons: [
        {
          title: "event.snow.button.collect",
          message: "event.snow.button.message.collect",
          effect: {},
        },
      ],
    },
    {
      title: "event.anxiety.title",
      baseWeight: 20,
      variants: [
        {
          season: "autumn",
          day: {
            description: "event.anxiety.autumn.day.description",
            effect: { health: -5 },
            weightAdjustment: 0,
          },
          night: {
            description: "event.anxiety.autumn.night.description",
            effect: { morale: -1, health: -3 },
            weightAdjustment: 5,
          },
        },
      ],
      buttons: [
        {
          title: "event.anxiety.button.calm",
          message: "event.anxiety.button.message.calm",
          effect: {},
        },
        {
          title: "event.anxiety.button.ignore",
          message: "event.anxiety.button.message.ignore",
          isDismiss: true,
        },
      ],
    },
    {
      title: "event.wildfolk.title",
      baseWeight: 20,
      isBuild: true,
      variants: [
        {
          season: "autumn",
          day: {
            description: "event.wildfolk.autumn.day.description",
            effect: { resources: { food: -10, ammo: -5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.wildfolk.autumn.night.description",
            effect: { resources: { food: -15, ammo: -10 } },
            weightAdjustment: 10,
          },
        },
      ],
      buttons: [
        {
          title: "event.wildfolk.button.search",
          message: "event.wildfolk.button.message.search",
          effect: { traits: { stealth: +1 } },
        },
        {
          title: "event.wildfolk.button.fortify",
          message: "event.wildfolk.button.message.fortify",
          effect: { traits: { resilience: +1 } },
        },
      ],
    },
    {
      title: "event.ill.title",
      baseWeight: 20,
      variants: [
        {
          season: "winter",
          day: {
            description: "event.ill.winter.day.description",
            effect: { health: -5 },
            weightAdjustment: 0,
          },
          night: {
            description: "event.ill.winter.night.description",
            effect: { health: -10, morale: -1 },
            weightAdjustment: 10,
          },
        },
      ],
      buttons: [
        {
          title: "event.ill.button.rest",
          message: "event.ill.button.message.rest",
          effect: { resources: { health: +5 } },
        },
        {
          title: "event.ill.button.tend",
          message: "event.ill.button.message.tend",
          effect: {},
        },
      ],
    },
    {
      title: "event.breeze.title",
      baseWeight: 20,
      variants: [
        {
          season: "autumn",
          day: {
            description: "event.breeze.autumn.day.description",
            effect: { health: +5 },
            weightAdjustment: 0,
          },
          night: {
            description: "event.breeze.autumn.night.description",
            effect: { morale: +1, health: +5 },
            weightAdjustment: 5,
          },
        },
      ],
      buttons: [
        {
          title: "event.breeze.button.enjoy",
          message: "event.breeze.button.message.enjoy",
          effect: {},
        },
      ],
    },
    {
      title: "event.hunt.title",
      baseWeight: 20,
      variants: [
        {
          season: "autumn",
          day: {
            description: "event.hunt.autumn.day.description",
            effect: { resources: { food: +15 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.hunt.autumn.night.description",
            effect: { resources: { food: +20 } },
            weightAdjustment: 5,
          },
        },
      ],
      buttons: [
        {
          title: "event.hunt.button.track",
          message: "event.hunt.button.message.track",
          effect: {},
        },
      ],
    },
    {
      title: "event.mudslide.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.mudslide.spring.day.description",
            effect: { resources: { ammo: -5, food: -5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.mudslide.spring.night.description",
            effect: { resources: { ammo: -10, food: -10, morale: -1 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.mudslide.summer.day.description",
            effect: { resources: { ammo: -5, food: -5 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.mudslide.summer.night.description",
            effect: { resources: { ammo: -7, food: -7, morale: -2 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.mudslide.autumn.day.description",
            effect: { resources: { ammo: -6, food: -6 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.mudslide.autumn.night.description",
            effect: { resources: { ammo: -8, food: -8, morale: -1 } },
            weightAdjustment: 15,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.mudslide.winter.day.description",
            effect: { resources: { ammo: -4, food: -4 } },
            weightAdjustment: -10,
          },
          night: {
            description: "event.mudslide.winter.night.description",
            effect: { resources: { ammo: -6, food: -6, morale: -2 } },
            weightAdjustment: 0,
          },
        },
      ],
      buttons: [
        {
          title: "event.mudslide.button.secure",
          message: "event.mudslide.button.message.secure",
          effect: {},
        },
        {
          title: "event.mudslide.button.evade",
          message: "event.mudslide.button.message.evade",
          effect: {},
        },
      ],
    },
    {
      title: "event.lightning.title",
      baseWeight: 20,
      variants: [
        {
          season: "summer",
          day: {
            description: "event.lightning.summer.day.description",
            effect: {
              health: -5,
              resources: { food: -20, water: -10, ammo: -10 },
            },
            weightAdjustment: 0,
          },
          night: {
            description: "event.lightning.summer.night.description",
            effect: {
              resources: {
                food: -30,
                water: -15,
                ammo: -15,
                morale: -1,
                health: -10,
              },
            },
            weightAdjustment: 10,
          },
        },
      ],
      buttons: [
        {
          title: "event.lightning.button.recover",
          message: "event.lightning.button.message.recover",
          effect: {},
        },
        {
          title: "event.lightning.button.moveOn",
          message: "event.lightning.button.message.moveOn",
          effect: {},
        },
      ],
    },
    {
      title: "event.setback.title",
      baseWeight: 20,
      variants: [
        {
          season: "summer",
          day: {
            description: "event.setback.summer.day.description",
            effect: { resources: { water: -10 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.setback.summer.night.description",
            effect: { resources: { water: -15, morale: -1 } },
            weightAdjustment: 5,
          },
        },
      ],
      buttons: [
        {
          title: "event.setback.button.conserve",
          message: "event.setback.button.message.conserve",
          effect: {},
        },
        {
          title: "event.setback.button.seekMore",
          message: "event.setback.button.message.seekMore",
          effect: {},
        },
      ],
    },
    {
      title: "event.pond.title",
      baseWeight: 20,
      variants: [
        {
          season: "summer",
          day: {
            description: "event.pond.summer.day.description",
            effect: { health: +10 },
            weightAdjustment: 0,
          },
          night: {
            description: "event.pond.summer.night.description",
            effect: { health: +15, morale: +1 },
            weightAdjustment: 5,
          },
        },
      ],
      buttons: [
        {
          title: "event.pond.button.relax",
          message: "event.pond.button.message.relax",
          effect: {},
        },
        {
          title: "event.pond.button.continue",
          message: "event.pond.button.message.continue",
          effect: {},
        },
      ],
    },
    {
      title: "event.winds.title",
      isBuild: true,
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.winds.spring.day.description",
            effect: { health: -5 },
            weightAdjustment: -5,
          },
          night: {
            description: "event.winds.spring.night.description",
            effect: { health: -10, morale: -1 },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.winds.summer.day.description",
            effect: { health: -4 },
            weightAdjustment: -10,
          },
          night: {
            description: "event.winds.summer.night.description",
            effect: { health: -8, morale: -1 },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.winds.autumn.day.description",
            effect: { health: -3 },
            weightAdjustment: -15,
          },
          night: {
            description: "event.winds.autumn.night.description",
            effect: { health: -6, morale: -2 },
            weightAdjustment: -5,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.winds.winter.day.description",
            effect: { health: -7 },
            weightAdjustment: 0,
          },
          night: {
            description: "event.winds.winter.night.description",
            effect: { health: -12, morale: -2 },
            weightAdjustment: 10,
          },
        },
      ],
      buttons: [
        {
          title: "event.winds.button.embrace",
          message: "event.winds.button.message.embrace",
          effect: {},
        },
        {
          title: "event.winds.button.shield",
          message: "event.winds.button.message.shield",
          effect: {},
        },
      ],
    },
    {
      title: "event.bear.title",
      baseWeight: 20,
      isCombat: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.bear.spring.day.description",
            effect: { health: -15 },
            weightAdjustment: 5,
          },
          night: {
            description: "event.bear.spring.night.description",
            effect: { health: -20, morale: -1 },
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.bear.summer.day.description",
            effect: { health: -10 },
            weightAdjustment: 0,
          },
          night: {
            description: "event.bear.summer.night.description",
            effect: { health: -15, morale: -1 },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.bear.autumn.day.description",
            effect: { health: -12 },
            weightAdjustment: -5,
          },
          night: {
            description: "event.bear.autumn.night.description",
            effect: { health: -18, morale: -2 },
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.bear.winter.day.description",
            effect: { health: -20 },
            weightAdjustment: -10,
          },
          night: {
            description: "event.bear.winter.night.description",
            effect: { health: -25, morale: -3 },
            weightAdjustment: 15,
          },
        },
      ],
      buttons: [
        {
          title: "event.bear.button.fight",
          combat: {
            description: "event.bear.button.message.fight",
            victory: "event.bear.button.message.fight.victory",
            defeat: "event.bear.button.message.fight.defeat",
            enemies: ["bear"],
          },
        },
        {
          title: "event.bear.button.flee",
          message: "event.bear.button.message.flee",
          effect: {},
        },
        {
          title: "event.bear.button.hide",
          message: "event.bear.button.message.hide",
          effect: {},
        },
      ],
    },
    {
      title: "event.pollen.title",
      baseWeight: 20,
      isBuild: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.pollen.spring.day.description",
            effect: { health: -5 },
            weightAdjustment: 0,
          },
          night: {
            description: "event.pollen.spring.night.description",
            effect: { health: -10, morale: -1 },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.pollen.summer.day.description",
            effect: { health: -7 },
            weightAdjustment: -5,
          },
          night: {
            description: "event.pollen.summer.night.description",
            effect: { health: -12, morale: -2 },
            weightAdjustment: 10,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.pollen.autumn.day.description",
            effect: { health: -4 },
            weightAdjustment: -10,
          },
          night: {
            description: "event.pollen.autumn.night.description",
            effect: { health: -8, morale: -1 },
            weightAdjustment: 0,
          },
        },
      ],
      buttons: [
        {
          title: "event.pollen.button.seekShelter",
          message: "event.pollen.button.message.seekShelter",
          effect: {},
        },
        {
          title: "event.pollen.button.endure",
          message: "event.pollen.button.message.endure",
          effect: {},
        },
      ],
    },
    {
      title: "event.relaxed.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.relaxed.spring.day.description",
            effect: { health: +10 },
            weightAdjustment: 0,
          },
          night: {
            description: "event.relaxed.spring.night.description",
            effect: { health: +15, morale: +1 },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.relaxed.summer.day.description",
            effect: { health: +8 },
            weightAdjustment: -5,
          },
          night: {
            description: "event.relaxed.summer.night.description",
            effect: { health: +12, morale: +2 },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.relaxed.autumn.day.description",
            effect: { health: +7 },
            weightAdjustment: -10,
          },
          night: {
            description: "event.relaxed.autumn.night.description",
            effect: { health: +10, morale: +1 },
            weightAdjustment: -5,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.relaxed.winter.day.description",
            effect: { health: +5 },
            weightAdjustment: -15,
          },
          night: {
            description: "event.relaxed.winter.night.description",
            effect: { health: +8, morale: +1 },
            weightAdjustment: -10,
          },
        },
      ],
      buttons: [
        {
          title: "event.relaxed.button.savor",
          message: "event.relaxed.button.message.savor",
          effect: {},
        },
        {
          title: "event.relaxed.button.resume",
          message: "event.relaxed.button.message.resume",
          effect: {},
        },
      ],
    },
    {
      title: "event.spring.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.spring.day.description",
            effect: { resources: { food: +10 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.spring.night.description",
            effect: { resources: { food: +15, morale: +1 } },
            weightAdjustment: 5,
          },
        },
      ],
      buttons: [
        {
          title: "event.spring.button.forage",
          message: "event.spring.button.message.forage",
          effect: {},
        },
        {
          title: "event.spring.button.moveOn",
          message: "event.spring.button.message.moveOn",
          effect: {},
        },
      ],
    },
    {
      title: "event.tradingPost.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.tradingPost.spring.day.description",
            effect: { resources: { coins: +10 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.tradingPost.spring.night.description",
            effect: { resources: { coins: +15, morale: +1 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.tradingPost.summer.day.description",
            effect: { resources: { coins: +10 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.tradingPost.summer.night.description",
            effect: { resources: { coins: +15, morale: +2 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.tradingPost.autumn.day.description",
            effect: { resources: { coins: +10 } },
            weightAdjustment: -10,
          },
          night: {
            description: "event.tradingPost.autumn.night.description",
            effect: { resources: { coins: +15, morale: +1 } },
            weightAdjustment: -5,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.tradingPost.winter.day.description",
            effect: { resources: { coins: +10 } },
            weightAdjustment: -15,
          },
          night: {
            description: "event.tradingPost.winter.night.description",
            effect: { resources: { coins: +20, morale: +1 } },
            weightAdjustment: 10,
          },
        },
      ],
      buttons: [
        {
          title: "event.tradingPost.button.trade",
          message: "event.tradingPost.button.message.trade",
          effect: {},
        },
        {
          title: "event.tradingPost.button.depart",
          message: "event.tradingPost.button.message.depart",
          effect: {},
        },
      ],
    },

    {
      title: "event.buffalo.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.buffalo.spring.day.description",
            effect: { resources: { ammo: -2, food: +20 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.buffalo.spring.night.description",
            effect: { resources: { ammo: -2, food: +25, morale: +1 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.buffalo.summer.day.description",
            effect: { resources: { ammo: -2, food: +20 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.buffalo.summer.night.description",
            effect: { resources: { ammo: -2, food: +25, morale: +2 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.buffalo.autumn.day.description",
            effect: { resources: { ammo: -2, food: +20 } },
            weightAdjustment: -10,
          },
          night: {
            description: "event.buffalo.autumn.night.description",
            effect: { resources: { ammo: -2, food: +25, morale: +1 } },
            weightAdjustment: -5,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.buffalo.winter.day.description",
            effect: { resources: { ammo: -3, food: +20 } },
            weightAdjustment: -15,
          },
          night: {
            description: "event.buffalo.winter.night.description",
            effect: { resources: { ammo: -3, food: +30, morale: +1 } },
            weightAdjustment: 10,
          },
        },
      ],
      buttons: [
        {
          title: "event.buffalo.button.hunt",
          message: "event.buffalo.button.message.hunt",
          effect: {},
        },
        {
          title: "event.buffalo.button.observe",
          message: "event.buffalo.button.message.observe",
          effect: {},
        },
      ],
    },
    {
      title: "event.streams.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.streams.spring.day.description",
            effect: { resources: { water: +10 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.streams.spring.night.description",
            effect: { resources: { water: +15, morale: +1 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.streams.summer.day.description",
            effect: { resources: { water: +8 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.streams.summer.night.description",
            effect: { resources: { water: +10, morale: +1 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.streams.autumn.day.description",
            effect: { resources: { water: +7 } },
            weightAdjustment: -10,
          },
          night: {
            description: "event.streams.autumn.night.description",
            effect: { resources: { water: +9, morale: +1 } },
            weightAdjustment: -5,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.streams.winter.day.description",
            effect: { resources: { water: +5 } },
            weightAdjustment: -15,
          },
          night: {
            description: "event.streams.winter.night.description",
            effect: { resources: { water: +7, morale: +1 } },
            weightAdjustment: -10,
          },
        },
      ],
      buttons: [
        {
          title: "event.streams.button.collect",
          message: "event.streams.button.message.collect",
          effect: {},
        },
        {
          title: "event.streams.button.moveOn",
          message: "event.streams.button.message.moveOn",
          effect: {},
        },
      ],
    },
    {
      title: "event.bandits.title",
      baseWeight: 20,
      isCombat: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.bandits.spring.day.description",
            effect: { resources: { coins: -10, food: -10, ammo: -5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.bandits.spring.night.description",
            effect: {
              resources: { coins: -15, food: -15, ammo: -10, morale: -1 },
            },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.bandits.summer.day.description",
            effect: { resources: { coins: -10, food: -10, ammo: -5 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.bandits.summer.night.description",
            effect: {
              resources: { coins: -15, food: -15, ammo: -10, morale: -2 },
            },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.bandits.autumn.day.description",
            effect: { resources: { coins: -10, food: -10, ammo: -5 } },
            weightAdjustment: -10,
          },
          night: {
            description: "event.bandits.autumn.night.description",
            effect: {
              resources: { coins: -15, food: -15, ammo: -10, morale: -1 },
            },
            weightAdjustment: -5,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.bandits.winter.day.description",
            effect: { resources: { coins: -10, food: -10, ammo: -5 } },
            weightAdjustment: -15,
          },
          night: {
            description: "event.bandits.winter.night.description",
            effect: {
              resources: { coins: -20, food: -20, ammo: -15, morale: -3 },
            },
            weightAdjustment: 10,
          },
        },
      ],
      buttons: [
        {
          title: "event.bandits.button.evade",
          message: "event.bandits.button.message.evade",
          effect: {},
        },
        {
          title: "event.bandits.button.confront",
          message: "event.bandits.button.message.confront",
          combat: {
            description: "event.bandits.button.message.confront",
            victory: "event.bandits.button.message.confront.victory",
            defeat: "event.bandits.button.message.confront.defeat",
            enemies: ["bandit", "bandit"],
          },
          effect: {},
        },
      ],
    },
    {
      title: "event.warmth.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.warmth.spring.day.description",
            effect: { health: +5 },
            weightAdjustment: 0,
          },
          night: {
            description: "event.warmth.spring.night.description",
            effect: { health: +7, morale: +1 },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.warmth.summer.day.description",
            effect: { health: +5 },
            weightAdjustment: -5,
          },
          night: {
            description: "event.warmth.summer.night.description",
            effect: { health: +7, morale: +2 },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.warmth.autumn.day.description",
            effect: { health: +4 },
            weightAdjustment: -10,
          },
          night: {
            description: "event.warmth.autumn.night.description",
            effect: { health: +6, morale: +1 },
            weightAdjustment: -5,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.warmth.winter.day.description",
            effect: { health: +3 },
            weightAdjustment: -15,
          },
          night: {
            description: "event.warmth.winter.night.description",
            effect: { health: +5, morale: +1 },
            weightAdjustment: -10,
          },
        },
      ],
      buttons: [
        {
          title: "event.warmth.button.enjoy",
          message: "event.warmth.button.message.enjoy",
          effect: {},
        },
        {
          title: "event.warmth.button.continue",
          message: "event.warmth.button.message.continue",
          effect: {},
        },
      ],
    },
    {
      title: "event.heat.title",
      baseWeight: 20,
      isBuild: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.heat.spring.day.description",
            effect: { resources: { water: -5 } },
            weightAdjustment: -10,
          },
          night: {
            description: "event.heat.spring.night.description",
            effect: { resources: { water: -7, morale: -1 } },
            weightAdjustment: -5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.heat.summer.day.description",
            effect: { resources: { water: -10 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.heat.summer.night.description",
            effect: { resources: { water: -12, morale: -2 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.heat.autumn.day.description",
            effect: { resources: { water: -8 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.heat.autumn.night.description",
            effect: { resources: { water: -10, morale: -1 } },
            weightAdjustment: 0,
          },
        },
      ],
      buttons: [
        {
          title: "event.heat.button.conserve",
          message: "event.heat.button.message.conserve",
          effect: {},
        },
        {
          title: "event.heat.button.seekShade",
          message: "event.heat.button.message.seekShade",
          effect: {},
        },
      ],
    },
    {
      title: "event.drought.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.drought.spring.day.description",
            effect: { resources: { food: -15 } },
            weightAdjustment: -10,
          },
          night: {
            description: "event.drought.spring.night.description",
            effect: { resources: { food: -20, morale: -1 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.drought.summer.day.description",
            effect: { resources: { food: -20 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.drought.summer.night.description",
            effect: { resources: { food: -25, morale: -2 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.drought.autumn.day.description",
            effect: { resources: { food: -20 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.drought.autumn.night.description",
            effect: { resources: { food: -20, morale: -1 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.drought.winter.day.description",
            effect: { resources: { food: -10 } },
            weightAdjustment: -15,
          },
          night: {
            description: "event.drought.winter.night.description",
            effect: { resources: { food: -15, morale: -1 } },
            weightAdjustment: -10,
          },
        },
      ],
      buttons: [
        {
          title: "event.drought.button.forage",
          message: "event.drought.button.message.forage",
          effect: {},
        },
        {
          title: "event.drought.button.conserve",
          message: "event.drought.button.message.conserve",
          effect: {},
        },
      ],
    },
    {
      title: "event.locals.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.locals.spring.day.description",
            effect: { resources: { ammo: +15 } },
            weightAdjustment: -10,
          },
          night: {
            description: "event.locals.spring.night.description",
            effect: { resources: { ammo: +20, morale: +1 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.locals.summer.day.description",
            effect: { resources: { ammo: +15 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.locals.summer.night.description",
            effect: { resources: { ammo: +20, morale: +2 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.locals.autumn.day.description",
            effect: { resources: { ammo: +15 } },
            weightAdjustment: -15,
          },
          night: {
            description: "event.locals.autumn.night.description",
            effect: { resources: { ammo: +20, morale: +1 } },
            weightAdjustment: -10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.locals.winter.day.description",
            effect: { resources: { ammo: +20 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.locals.winter.night.description",
            effect: { resources: { ammo: +25, morale: +1 } },
            weightAdjustment: 5,
          },
        },
      ],
      buttons: [
        {
          title: "event.locals.button.trade",
          message: "event.locals.button.message.trade",
          effect: {},
        },
        {
          title: "event.locals.button.thank",
          message: "event.locals.button.message.thank",
          effect: {},
        },
      ],
    },
    {
      title: "event.storm.title",
      baseWeight: 20,
      isBuild: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.storm.spring.day.description",
            effect: { resources: { health: -5, food: -8 } },
            weightAdjustment: -10,
          },
          night: {
            description: "event.storm.spring.night.description",
            effect: { resources: { health: -10, food: -12, morale: -1 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.storm.summer.day.description",
            effect: { resources: { health: -4, food: -7 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.storm.summer.night.description",
            effect: { resources: { health: -8, food: -10, morale: -2 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.storm.autumn.day.description",
            effect: { resources: { health: -5, food: -9 } },
            weightAdjustment: -15,
          },
          night: {
            description: "event.storm.autumn.night.description",
            effect: { resources: { health: -10, food: -11, morale: -1 } },
            weightAdjustment: -10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.storm.winter.day.description",
            effect: { resources: { health: -7, food: -10 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.storm.winter.night.description",
            effect: { resources: { health: -12, food: -15, morale: -3 } },
            weightAdjustment: 10,
          },
        },
      ],
      buttons: [
        {
          title: "event.storm.button.shelter",
          message: "event.storm.button.message.shelter",
          effect: { resources: { health: -5 }, traits: { resilience: +1 } },
        },
        {
          title: "event.storm.button.recover",
          message: "event.storm.button.message.recover",
          effect: { resources: { health: +5 } },
        },
      ],
    },
    {
      title: "event.tradingPost2.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.tradingPost2.spring.day.description",
            effect: { resources: { ammo: +20, coins: -1 } },
            weightAdjustment: -10,
          },
          night: {
            description: "event.tradingPost2.spring.night.description",
            effect: { resources: { ammo: +25, coins: -1 }, morale: +1 },
            weightAdjustment: 0,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.tradingPost2.summer.day.description",
            effect: { resources: { ammo: +20, coins: -1 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.tradingPost2.summer.night.description",
            effect: { resources: { ammo: +25, coins: -1 }, morale: +2 },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.tradingPost2.autumn.day.description",
            effect: { resources: { ammo: +20, coins: -1 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.tradingPost2.autumn.night.description",
            effect: { resources: { ammo: +25, coins: -1 }, morale: +1 },
            weightAdjustment: -5,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.tradingPost2.winter.day.description",
            effect: { resources: { ammo: +20, coins: -2 } },
            weightAdjustment: -15,
          },
          night: {
            description: "event.tradingPost2.winter.night.description",
            effect: { resources: { ammo: +30, coins: -3 }, morale: +1 },
            weightAdjustment: 10,
          },
        },
      ],
      buttons: [
        {
          title: "event.tradingPost2.button.trade",
          message: "event.tradingPost2.button.message.trade",
          effect: {},
        },
        {
          title: "event.tradingPost2.button.depart",
          message: "event.tradingPost2.button.message.depart",
          isDismiss: true,
          effect: {},
        },
      ],
    },
  ].map((event) => localized(event, localizationData));

export { borderEvents, randomEvents, specialEvents };
